// extracted by mini-css-extract-plugin
export default {"cls1":"p3AOfXHHM4Zz4AzghhKr","cls2":"B52Gmv24rS1N328_nHUH p3AOfXHHM4Zz4AzghhKr","isPhone":"XXoo_mH4iw0xhUP3hbA9"};